export enum ResourceType {
    Approvals = 'approvals',
    Incidents = 'incidents',
    Requests = 'requests',
}